<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start" *ngIf="checkBackBtn()">
      <ion-button (click)="goBack()">
        <ion-icon color="dark" class="back-icon" name="chevron-back"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      <app-offline-indicator></app-offline-indicator>
      {{ 'STRIPE.status.title' | translate }}
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div class="font-14 full-width-height vertical-center ion-text-center">
    <div class="ion-margin">
      <ng-container *ngIf="sessionStatus === 'complete'">
        <ng-container *ngIf="paymentStatus !== 'unpaid'">
          <div>
            <ion-text [innerHTML]="'STRIPE.status.msg.complete' | translate"></ion-text>
          </div>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="sessionStatus !== 'complete' && !cancelCheckout">
        {{ 'STRIPE.status.msg.processing' | translate }}
      </ng-container>
    </div>
    <div class="full-width">
      <ion-skeleton-text animated></ion-skeleton-text>
    </div>
    
    <div class="ion-margin" *ngIf="((sessionStatus === 'complete' && paymentStatus !== 'paid') || cancelCheckout) && (transactionType && paymentStatus)">
      <ion-text>{{ 'STRIPE.status.msg.retry' | translate }}</ion-text>
      <ion-button class="ion-margin" expand="block" (click)="retry()">
        {{ 'BTN.retry' | translate }}
      </ion-button>
    </div>

    <div class="ion-margin" *ngIf="sessionStatus === 'complete' && paymentStatus && paymentStatus !== 'unpaid' && countdownConfig">
      <ion-text class="font-14">
        {{ 'STRIPE.status.msg.redirect_result' | translate }} 
        <ion-text class="font-bold">
          <countdown #cd [config]="countdownConfig" (event)="handleEvent($event)" *ngIf="countdownConfig?.leftTime"></countdown>
          <ng-container *ngIf="!countdownConfig?.leftTime">0</ng-container>
        </ion-text> 
        {{ 'LBL.second_s' | translate }}
      </ion-text>
      <div>
        <ion-text class="font-12 font-underline" (click)="goResultPage()">
          {{ 'STRIPE.status.msg.redirect_now' | translate }}
        </ion-text>
      </div>
    </div>
  </div>
</ion-content>
<ion-footer *ngIf="showAppBtn">
  <ion-toolbar class="ion-text-center ion-padding">
    <div class="content-div">
      <div>
        <ion-text class="font-12">{{ 'STRIPE.status.msg.open_app' | translate }}</ion-text>
      </div>
      <ion-button expand="block" (click)="backApp()" *ngIf="showAppBtn">
        {{ 'MSG.continue_app' | translate }}
      </ion-button>
    </div>
  </ion-toolbar>
</ion-footer>
